export const getIdFromStockCode = (value: string) => {
  const stringEndsWithLetter = /[a-zA-Z]$/
  const match = value.match(stringEndsWithLetter)
  const offset = match ? 3 : 2
  const modelIdMatch = value.substring(0, value.length - offset).match(/[0-9]/g)

  return modelIdMatch ? parseInt(modelIdMatch.join('')) : undefined
}

export const extractImageIndexFromPath = (path: string) => {
  const index = path.split('_').pop()?.split('-').shift()?.split('.').shift()
  const numberIndex = index ? Number(index) : null

  return numberIndex
}
